<div
  class="flex flex-col justify-between lg:hidden bg-gray-800 w-full"
  [ngClass]="{
    hidden: customLayout === true,
    'flex lg:hidden ': customLayout !== true
  }"
  data-test-id="wrapper">
  <div class="flex items-center justify-between">
    <a href="https://app.onafriq.com/" target="_blank"
      ><img
        class="cursor-pointer p-2 w-[150px]"
        src="assets/images/logo/full-white.svg"
        alt="logo"
        width="155"
        height="55"
    /></a>

    <div class="flag relative">
      <div class="i-content bg-blue-400 rounded-l-lg rounded-br-lg hidden p-2 w-40 absolute right-10 top-5">
        <span class="text-sm text-white font-normal leading-3"> We are currently only available in Uganda </span>
      </div>
      <img src="https://flagcdn.com/ug.svg" class="h-5 w-5 mr-5 rounded-full" alt="country" />
    </div>
  </div>
</div>
